import {
  LICENSE_STATUS_VALUES,
} from './licenseConstants';
import { validateLimitValue } from './licenseLimitUtils';

export function validateLicenseForm(form) {
  const errors = {};

  const name = (form.name || '').trim();
  if (!name) {
    errors.name = 'License name is required';
  } else if (name.length < 2) {
    errors.name = 'Name must be at least 2 characters';
  } else if (name.length > 80) {
    errors.name = 'Name must be 80 characters or less';
  }

  const alias = (form.alias || '').trim();
  if (!alias) {
    errors.alias = 'Alias is required';
  } else if (alias.length < 2) {
    errors.alias = 'Alias must be at least 2 characters';
  } else if (alias.length > 30) {
    errors.alias = 'Alias must be 30 characters or less';
  }

  if (!form.status) {
    errors.status = 'Select license status';
  } else if (!LICENSE_STATUS_VALUES.includes(form.status)) {
    errors.status = 'Invalid license status selected';
  }

  const description = (form.description || '').trim();
  if (description.length > 300) {
    errors.description = 'Description must be 300 characters or less';
  }

  const durationError = validateLimitValue(form.durationMonths, {
    requiredMessage: 'Select a duration',
    invalidMessage: 'Enter a valid duration in months (minimum 1)',
  });
  if (durationError) {
    errors.durationMonths = durationError;
  }

  if (!form.permissionProfileId) {
    errors.permissionProfileId = 'Select a permission profile';
  }

  const maxUsersError = validateLimitValue(form.maxUsers, {
    requiredMessage: 'Select number of users',
    invalidMessage: 'Enter a valid user count (minimum 1)',
  });
  if (maxUsersError) {
    errors.maxUsers = maxUsersError;
  }

  const aiCreditsError = validateLimitValue(form.aiCredits, {
    requiredMessage: 'Select AI credits limit',
    invalidMessage: 'Enter a valid credit amount (minimum 1)',
  });
  if (aiCreditsError) {
    errors.aiCredits = aiCreditsError;
  }

  const price = form.price;
  if (price === '' || price === null || price === undefined) {
    errors.price = 'Plan price is required';
  } else {
    const amount = Number(price);
    if (Number.isNaN(amount) || amount < 0) {
      errors.price = 'Enter a valid plan price';
    } else if (amount > 100000000) {
      errors.price = 'Price is too large';
    }
  }

  const trialDays = Number(form.trialDays ?? 0);
  if (Number.isNaN(trialDays) || trialDays < 0) {
    errors.trialDays = 'Trial days cannot be negative';
  }

  return errors;
}

export function hasValidationErrors(errors) {
  return Object.keys(errors).length > 0;
}
